/**
 * Helper do dataLayer z bramką zgody marketingowej (Cookiebot).
 *
 * Eventy niosące dane marketingowe / PII trafiają do dataLayer tylko gdy
 * użytkownik wyraził zgodę marketingową w Cookiebocie. Bez zgody (albo gdy
 * Cookiebot nie jest jeszcze załadowany, np. poza prod) nie pushujemy nic.
 */

export function hasMarketingConsent() {
    return !!(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.marketing);
}

export function trackEvent(payload) {
    if (!hasMarketingConsent()) {
        return false;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    return true;
}
